import { render, staticRenderFns } from "./orderslisting.vue?vue&type=template&id=5aed555c"
import script from "./orderslisting.vue?vue&type=script&lang=js"
export * from "./orderslisting.vue?vue&type=script&lang=js"
import style0 from "./orderslisting.vue?vue&type=style&index=0&id=5aed555c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports